import RODThumbnail from "../../assests/RealmOfDiety-Thumbnail.png";
import RODTitle from "../../assests/RealmOfDiety-title.png";
import WrathAndRosesThumbNail from "../../assests/WrathAndRoses-thumbnail.png";
import WrathAndRosesTitle from "../../assests/WrathAndRoses-title.png";
import AmazoniaSecretsThumbnail from "../../assests/Amazonia-bg.jpg";
import AmazoniaSecretsTitle from "../../assests/Amazonia-title.png";
import BlackjackThumbnail from "../../assests/Blackjack-thumbnail.jpg";
import BlackjackTitle from "../../assests/blackjack-title.png";
import WorldOfWisdomThumbnail from "../../assests/World-of-Wisdom_Bg.png";
import WorldOfWisdomTitle from "../../assests/World-of-Wisdom_Title.png";
import ArialFortuneThumbnail from "../../assests/Aviator_Bg_Jet.png";
import ArialFortuneTitle from "../../assests/Aviator_Title.png";
import JewelBlitzThumbnail from "../../assests/Thumbnail_500x660.png";
import JewelBlitzTitle from "../../assests/Thumbnail_Titel.png";
import FlappyBeeThumbnail from "../../assests/flappyBeeThumbnail (1).png";
import SpinAndWinThumbnail from "../../assests/spin_and_win.png";
import HiddenObjectsThumbnail from "../../assests/Thumbnail_house_bg.png";
import HiddenObjectsTitle from "../../assests/Thumbnail_house_title.png";


interface GameDetails {
  id: number;
  gameName: string;
  imageSource: string;
  title?: string;
  gameType: string;
  gameEnabled: boolean;
  currency: string;
  className: string;
  isComingSoon?: boolean;
}

export const GameBannerDetails: GameDetails[] = [
  {
    id: 11,
    gameName: "REALM OF DEITY",
    imageSource: RODThumbnail,
    title: RODTitle,
    gameType: "SlotGames",
    gameEnabled: true,
    currency: "USD",
    className: "realm-of-diety-title",
  },
  {
    id: 12,
    gameName: "Wrath & Roses",
    imageSource: WrathAndRosesThumbNail,
    title: WrathAndRosesTitle,
    gameType: "SlotGames",
    gameEnabled: true,
    currency: "EUR",
    className: "wrath-and-roses-title",
  },
  {
    id: 13,
    gameName: "Amazonia Secrets",
    imageSource: AmazoniaSecretsThumbnail,
    title: AmazoniaSecretsTitle,
    gameType: "SlotGames",
    gameEnabled: true,
    currency: "EUR",
    className: "amazonia-title",
  },
  {
    id: 14,
    gameName: "Blackjack Regalia",
    imageSource: BlackjackThumbnail,
    title: BlackjackTitle,
    gameType: "TableGames",
    gameEnabled: true,
    currency: "EUR",
    className: "blackjack-title",
  },
  {
    id: 19,
    gameName: "Aerial Fortune",
    imageSource: ArialFortuneThumbnail,
    title: ArialFortuneTitle,
    gameType: "",
    gameEnabled: true,
    currency: "EUR",
    className: "aerial-fortune-title",
  },
  {
    id: 20,
    gameName: "Jewel Blitz",
    imageSource: JewelBlitzThumbnail,
    title: JewelBlitzTitle,
    gameType: "CasualGames",
    gameEnabled: true,
    currency: "EUR",
    className: "jewel-blitz-title",
    isComingSoon: false
  },
  {
    id: 21,
    gameName: "Hidden Objects",
    imageSource: HiddenObjectsThumbnail,
    title: HiddenObjectsTitle,
    gameType: "CasualGames",
    gameEnabled: true,
    currency: "EUR",
    className: "hiddenTitle",
    isComingSoon: false
  },
];

interface UserData {
  username: string;
  rank: number;
  score: number;
  level: number;
}

export const userData: UserData[] = [
  { username: "User1", rank: 25, score: 65236235, level: 1 },
];

export const NO_GAME_AVAILABLE = "Coming soon!";
